import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { AppState } from 'src/app/shareModule/states/app.state';

@Component({
  selector: 'app-advanced-settings-super-seller-settings',
  templateUrl: './advanced-settings-super-seller-settings.component.html',
  styleUrls: [
    './advanced-settings-super-seller-settings.component.scss',
    '../advanced-settings.component.scss'
  ],
})
export class AdvancedSettingsSuperSellerSettingsComponent implements OnInit {

  public userInfo: any;

  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
  ) { }


  public superSellerFeatures: Array<any> = [
    'Extra details tab while adding store product',
    'Enable shout tab for product reference',
    'Enable Reference and store URL for store products',
    'Enable seller social media tab',
    'Enable more products',
    'Enable holiday option',
    'Add more product upto 12',
    'Enable Certified option',
    'Enable job posting option',
  ];

  ngOnInit(): void {

    this.store.pipe(select(selectUser)).subscribe((response: any) => {
      try {
        if (response) {
          const data = response;

          this.userInfo = {
            isVerified: data.isVerified,
            phone: data.phone,
            isEmailVerify: data.isEmailVerify,
            level: data.level,
            allowBookDriver: data.allowBookDriver,
          };

          this.cdr.detectChanges();
        }
      } catch (error) {
        console.log("error", error, "PROFILE")
      }
    });
  }

  ngAfterViewInit(): void {
  }
}
